
import IconAdd from '@/components/svg/checkmark-circle.svg?inline';
import IconAddFilled from '@/components/svg/checkmark-circle-inverted.svg?inline';
import IconEdit from '@/components/svg/edit-circle.svg?inline';
import IconCircle from '@/components/svg/circle.svg?inline';
import IconRemove from '@/components/svg/minus-circle.svg?inline';
import IconMoveUp from '@/components/svg/arrow-up-circle.svg?inline';
import IconUpload from '@/components/svg/upload-circle.svg?inline';
import IconDownload from '@/components/svg/download-circle.svg?inline';
import IconQuestionMark from '@/components/svg/questionmark-circle.svg?inline';
import IconPlus from '@/components/svg/plus-circle.svg?inline';
import IconPlusFilled from '@/components/svg/plus-filled-circle.svg?inline';
import IconCopy from '@/components/svg/copy.svg?inline';
import IconView from '@/components/svg/view-2.svg?inline';
import IconX from '@/components/svg/x-circle.svg?inline';
import IconX2 from '@/components/svg/x-circle-2.svg?inline';
import IconOpenEnvelope from '@/components/svg/envelope-open.svg?inline';
import IconResendEnvelope from '@/components/svg/envelope-resend.svg?inline';
import IconArrowUp from '@/assets/svg/arrow-up.svg?inline';
import IconArrowDown from '@/assets/svg/arrow-down.svg?inline';
import IconRefresh2 from '@/components/svg/refresh-2.svg?inline';
import IconRefresh3 from '@/components/svg/refresh-3.svg?inline';
import { defineComponent, PropType } from 'vue';

const components = {
  IconAdd,
  IconAddFilled,
  IconCopy,
  IconRemove,
  IconMoveUp,
  IconUpload,
  IconDownload,
  IconQuestionMark,
  IconEdit,
  IconCircle,
  IconPlus,
  IconPlusFilled,
  IconView,
  IconX,
  IconX2,
  IconOpenEnvelope,
  IconResendEnvelope,
  IconArrowUp,
  IconArrowDown,
  IconRefresh2,
  IconRefresh3
};

type ComponentNames = keyof typeof components;
type CamelToKebab<S extends string> = S extends `${infer A}${infer B}`
  ? B extends Uncapitalize<B>
    ? `${Uncapitalize<A>}${CamelToKebab<B>}`
    : `${Uncapitalize<A>}-${CamelToKebab<B>}`
  : S;
type ExtractIconName<T> = T extends `Icon${infer Name}`
  ? CamelToKebab<Name>
  : never;
type ValidIconNames = ExtractIconName<ComponentNames>;

export default defineComponent({
  name: 'EditIcon',
  components,
  props: {
    icon: {
      type: String as PropType<ValidIconNames>,
      required: true
    },
    disabled: Boolean,
  },
  emits: ['execute'],
  setup(props, { emit }) {
    const onExecute = (event: Event) => {
      if (props.disabled) return;
      emit('execute', event);
    };

    return {
      onExecute
    };
  }
});
